import "swiper/css";
import "swiper/css/pagination";

import { Swiper, SwiperSlide } from "swiper/react";
import { useEffect, useState } from "react";

import { Pagination } from "swiper/modules";

export default function ApplicationsSection() {
  const [swiperSlides, setSwiperSlides] = useState(3.5);

  const checkWidth = () => {
    if (window.innerWidth > 1366) {
      setSwiperSlides(4.5);
    } else if (window.innerWidth > 1024) {
      setSwiperSlides(4);
    } else if (window.innerWidth > 968) {
      setSwiperSlides(3.5);
    } else if (window.innerWidth > 600) {
      setSwiperSlides(2);
    } else {
      setSwiperSlides(1.2);
    }
  };
  useEffect(() => {
    checkWidth();
    window.addEventListener("resize", checkWidth);
    return () => window.removeEventListener("resize", checkWidth);
  }, [swiperSlides]);
  return (
    <section className="applications__section">
      <div className="applications__section__content">
        <div className="applications__section__heading">Applications</div>
        <Swiper
          modules={[Pagination]}
          spaceBetween={40}
          slidesPerView={swiperSlides}
          pagination={{
            clickable: true,
          }}
          className="applications__section__content__cards"
        >
          <SwiperSlide>
            <div className="applications__section__content__card">
              <div className="applications__section__content__card__img">
                <svg
                  width="22"
                  height="29"
                  viewBox="0 0 22 29"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M1.38262 0.537493C0.603071 0.616362 0.00585938 1.28032 0.00585938 2.08215V27.334C0.00585938 28.1892 0.686836 28.8786 1.54212 28.8786H20.2963C21.1516 28.8786 21.8326 28.1892 21.8326 27.334V8.36152H16.1828C15.026 8.36152 14.0169 7.51771 14.0169 6.39712V0.537493H1.54212C1.48867 0.537493 1.43459 0.532236 1.38262 0.537493ZM15.0915 0.537493V6.39712C15.0915 6.8576 15.5299 7.28698 16.1828 7.28698H21.8326L15.0915 0.537493ZM8.24019 9.25081C8.35827 9.2381 8.47736 9.29591 8.53873 9.40664L9.23236 10.658C9.76477 10.4446 10.3388 10.3337 10.9192 10.3322C11.5002 10.3326 12.0749 10.4426 12.6082 10.6554L13.3002 9.40664C13.3616 9.29592 13.4807 9.2381 13.5987 9.25081C13.6381 9.25505 13.6773 9.26708 13.7142 9.28754C13.8618 9.36937 13.9151 9.5544 13.8333 9.70204L13.1564 10.923C14.3856 11.6225 15.148 12.8486 15.1822 14.1812H6.65828C6.69121 12.8484 7.45258 11.6214 8.68145 10.9209L8.00566 9.70204C7.92382 9.5544 7.97713 9.36937 8.12476 9.28754C8.16167 9.26708 8.20083 9.25505 8.24019 9.25081ZM8.95061 11.9912C8.75585 11.9912 8.59435 12.1527 8.59435 12.3475C8.59435 12.5422 8.75585 12.7037 8.95061 12.7037C9.14536 12.7037 9.30686 12.5422 9.30686 12.3475C9.30686 12.1527 9.14536 11.9912 8.95061 11.9912ZM12.8883 11.9912C12.6936 11.9912 12.5321 12.1527 12.5321 12.3475C12.5321 12.5422 12.6936 12.7037 12.8883 12.7037C13.0831 12.7037 13.2446 12.5422 13.2446 12.3475C13.2446 12.1527 13.0831 11.9912 12.8883 11.9912ZM5.19547 14.5721C5.75819 14.5721 6.21125 15.0252 6.21125 15.5879V19.1856C6.21125 19.7483 5.75819 20.2014 5.19547 20.2014C4.63275 20.2014 4.17969 19.7483 4.17969 19.1856V15.5879C4.17969 15.0252 4.63275 14.5721 5.19547 14.5721ZM16.6429 14.5721C17.2057 14.5721 17.6587 15.0252 17.6587 15.5879V19.1856C17.6587 19.7483 17.2057 20.2014 16.6429 20.2014C16.0802 20.2014 15.6272 19.7483 15.6272 19.1856V15.5879C15.6272 15.0252 16.0802 14.5721 16.6429 14.5721ZM6.65356 14.7479H15.1849V20.7854C15.1849 21.3567 14.7252 21.8164 14.1539 21.8164H13.9288C13.9423 21.8863 13.9503 21.9581 13.9503 22.032V26.0164C13.9503 26.6397 13.4486 27.1414 12.8254 27.1414C12.2021 27.1414 11.6999 26.6397 11.6999 26.0164V22.032C11.6999 21.9581 11.7079 21.8863 11.7214 21.8164H10.117C10.1305 21.8863 10.1385 21.9581 10.1385 22.032V26.0164C10.1385 26.6397 9.6363 27.1414 9.01305 27.1414C8.38979 27.1414 7.88813 26.6397 7.88813 26.0164V22.032C7.88813 21.9581 7.89615 21.8863 7.90964 21.8164H7.68508C7.11376 21.8164 6.65356 21.3567 6.65356 20.7854L6.65356 14.7479Z"
                    fill="white"
                  />
                </svg>
              </div>
              <div className="applications__section__content__card__heading">
                Understanding the Application
              </div>
              <div className="applications__section__content__card__info">
                We engage with our client to thoroughly understand their vision,
                needs, target market, and specific product application.
                Together, we outline the requirements, flavor profiles,
                regulatory considerations, preferred ingredients, and any
                potential challenges.
              </div>
            </div>
          </SwiperSlide>
          <SwiperSlide>
            <div className="applications__section__content__card">
              <div className="applications__section__content__card__img">
                <svg
                  width="32"
                  height="32"
                  viewBox="0 0 32 32"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M16.0976 0.535156C7.48127 0.535156 0.488281 7.52815 0.488281 16.1445C0.488281 24.7609 7.48127 31.7539 16.0976 31.7539C24.714 31.7539 31.707 24.7609 31.707 16.1445C31.707 7.52815 24.714 0.535156 16.0976 0.535156ZM16.0976 28.632C9.1983 28.632 3.61015 23.0438 3.61015 16.1445C3.61015 9.24517 9.1983 3.65703 16.0976 3.65703C22.997 3.65703 28.5851 9.24517 28.5851 16.1445C28.5851 23.0438 22.997 28.632 16.0976 28.632Z"
                    fill="white"
                  />
                  <path
                    d="M16.0973 22.3889C19.5456 22.3889 22.341 19.5934 22.341 16.1451C22.341 12.6968 19.5456 9.90137 16.0973 9.90137C12.6489 9.90137 9.85352 12.6968 9.85352 16.1451C9.85352 19.5934 12.6489 22.3889 16.0973 22.3889Z"
                    fill="white"
                  />
                </svg>
              </div>
              <div className="applications__section__content__card__heading">
                Flavor Selection and Formulation
              </div>
              <div className="applications__section__content__card__info">
                Guided by our research, our flavorists select and formulate the
                flavors. We take into account the unique requirements of the
                application, considering aspects like ingredient interactions,
                behavior under processing conditions, and sensory perception by
                consumers.
              </div>
            </div>
          </SwiperSlide>
          <SwiperSlide>
            <div className="applications__section__content__card">
              <div className="applications__section__content__card__img">
                <svg
                  width="31"
                  height="32"
                  viewBox="0 0 31 32"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M5.46742 6.57682C7.1263 4.59264 9.34367 3.09147 11.8779 2.31497C12.1702 1.53319 12.6739 0.85471 13.3169 0.34375C9.24228 1.02981 5.72134 3.34684 3.44865 6.60028C3.57415 6.58478 3.70173 6.57682 3.83085 6.57682H5.46742ZM2.61035 12.4661C2.05432 12.2284 1.5783 11.8332 1.2449 11.334C0.911897 12.5808 0.734375 13.8912 0.734375 15.243C0.734375 19.895 2.83672 24.0559 6.14314 26.8277L6.63691 25.1423C3.98416 22.6741 2.32486 19.1522 2.32486 15.243C2.32486 14.2912 2.42322 13.3623 2.61035 12.4661ZM12.1964 28.2643L11.7806 29.2497C11.7587 29.4282 11.7213 29.6016 11.67 29.7687C12.9957 30.1489 14.3961 30.3526 15.844 30.3526C17.2919 30.3526 18.6923 30.1489 20.018 29.7687C19.9667 29.6016 19.9293 29.4282 19.9074 29.2497L19.4916 28.2643C18.3313 28.5887 17.1079 28.7621 15.844 28.7621C14.5801 28.7621 13.3567 28.5887 12.1964 28.2643ZM25.0511 25.1423L25.5448 26.8277C28.8512 24.0559 30.9536 19.895 30.9536 15.243C30.9536 13.8912 30.7761 12.5808 30.4431 11.334C30.1097 11.8332 29.6337 12.2284 29.0776 12.4661C29.2647 13.3623 29.3631 14.2912 29.3631 15.243C29.3631 19.1522 27.7038 22.6741 25.0511 25.1423ZM26.2206 6.57682H27.8571C27.9862 6.57682 28.1138 6.58478 28.2394 6.60028C26.1408 3.59613 22.978 1.3904 19.2977 0.529877C19.9055 1.07778 20.3665 1.78489 20.6088 2.58747C22.8103 3.41675 24.7384 4.80399 26.2206 6.57682Z"
                    fill="#F8F8F8"
                  />
                  <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M16.197 0.131836C14.1148 0.131836 12.3898 1.8055 12.3898 3.88512C12.3898 5.46927 13.3907 6.81784 14.7881 7.37053H10.0842C10.5281 7.79313 10.8501 8.34272 10.9918 8.96102H27.8568C28.2595 8.96102 28.5676 9.28405 28.5676 9.64477C28.5676 10.0056 28.2595 10.3285 27.8568 10.3285H19.2869H18.2253L18.5237 11.3474L19.0809 13.2494C19.5359 12.9985 20.0589 12.8557 20.6151 12.8557H20.623L20.3486 11.919H27.8568C29.1107 11.919 30.158 10.911 30.158 9.64477C30.158 8.37866 29.1107 7.37053 27.8568 7.37053H17.606C19.0033 6.81784 20.0042 5.46927 20.0042 3.88512C20.0042 1.80551 18.2792 0.131836 16.197 0.131836ZM23.6847 28.9635L20.8275 19.2107C21.3819 19.1742 21.8975 18.9956 22.3383 18.7109L25.2497 28.6485L25.2819 28.758V28.8721C25.2819 30.1382 24.2344 31.1463 22.9806 31.1463C21.9771 31.1463 21.2337 30.3927 20.723 29.6601C20.1813 28.8827 19.7165 27.8631 19.3223 26.843C18.9247 25.8142 18.581 24.7364 18.2955 23.8236L18.2019 23.524C18.0465 23.0261 17.9143 22.6027 17.802 22.2722H16.5033C16.3106 21.6343 15.9228 21.0811 15.4095 20.6817H16.0024H18.3548H18.8824L19.0875 21.1678C19.2637 21.5856 19.4784 22.2744 19.716 23.0367L19.8134 23.3488C20.0986 24.2605 20.4289 25.2942 20.8058 26.2697C21.1862 27.254 21.5965 28.1318 22.0279 28.7507C22.4903 29.4142 22.8179 29.5558 22.9806 29.5558C23.3489 29.5558 23.638 29.2857 23.6847 28.9635ZM10.8815 26.2697C10.9889 25.992 11.0923 25.7096 11.1921 25.4265C11.5723 25.8122 12.05 26.1014 12.5855 26.2537C12.514 26.451 12.4405 26.6479 12.365 26.843C11.9708 27.8631 11.506 28.8827 10.9643 29.6601C10.4537 30.3927 9.7102 31.1463 8.70676 31.1463C7.4529 31.1463 6.40557 30.1382 6.40557 28.8721V28.758L6.43762 28.6485L11.3388 11.919H10.1455C10.5717 11.491 10.8767 10.9422 11.0049 10.3285H12.4004H13.4621L13.1636 11.3474L8.00265 28.9635C8.04933 29.2857 8.33849 29.5558 8.70676 29.5558C8.86947 29.5558 9.19703 29.4142 9.65946 28.7507C10.0908 28.1318 10.5011 27.254 10.8815 26.2697ZM5.63697 11.919C5.21079 11.491 4.90574 10.9422 4.77755 10.3285H3.83053C3.42783 10.3285 3.11978 10.0056 3.11978 9.64477C3.11978 9.28405 3.42783 8.96102 3.83053 8.96102H4.79067C4.93238 8.34272 5.25437 7.79313 5.69828 7.37053H3.83053C2.57665 7.37053 1.5293 8.37866 1.5293 9.64477C1.5293 10.911 2.57665 11.919 3.83053 11.919H5.63697ZM13.9803 3.88512C13.9803 2.71089 14.966 1.72232 16.197 1.72232C17.428 1.72232 18.4137 2.71089 18.4137 3.88512C18.4137 5.05932 17.428 6.04789 16.197 6.04789C14.966 6.04789 13.9803 5.05932 13.9803 3.88512Z"
                    fill="#F8F8F8"
                  />
                  <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M7.89191 11.2656C8.77034 11.2656 9.4824 10.5535 9.4824 9.67511C9.4824 8.79669 8.77034 8.08463 7.89191 8.08463C7.01348 8.08463 6.30142 8.79669 6.30142 9.67511C6.30142 10.5535 7.01348 11.2656 7.89191 11.2656ZM7.89191 12.8561C9.64868 12.8561 11.0729 11.4319 11.0729 9.67511C11.0729 7.91834 9.64868 6.49414 7.89191 6.49414C6.13514 6.49414 4.71094 7.91834 4.71094 9.67511C4.71094 11.4319 6.13514 12.8561 7.89191 12.8561Z"
                    fill="#F8F8F8"
                  />
                  <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M20.6146 17.6269C21.493 17.6269 22.2051 16.9149 22.2051 16.0364C22.2051 15.158 21.493 14.446 20.6146 14.446C19.7361 14.446 19.0241 15.158 19.0241 16.0364C19.0241 16.9149 19.7361 17.6269 20.6146 17.6269ZM20.6146 19.2174C22.3713 19.2174 23.7955 17.7932 23.7955 16.0364C23.7955 14.2797 22.3713 12.8555 20.6146 12.8555C18.8578 12.8555 17.4336 14.2797 17.4336 16.0364C17.4336 17.7932 18.8578 19.2174 20.6146 19.2174Z"
                    fill="#F8F8F8"
                  />
                  <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M13.4583 24.7842C14.3367 24.7842 15.0488 24.0721 15.0488 23.1937C15.0488 22.3152 14.3367 21.6032 13.4583 21.6032C12.5799 21.6032 11.8678 22.3152 11.8678 23.1937C11.8678 24.0721 12.5799 24.7842 13.4583 24.7842ZM13.4583 26.3746C15.2151 26.3746 16.6393 24.9504 16.6393 23.1937C16.6393 21.4369 15.2151 20.0127 13.4583 20.0127C11.7015 20.0127 10.2773 21.4369 10.2773 23.1937C10.2773 24.9504 11.7015 26.3746 13.4583 26.3746Z"
                    fill="#F8F8F8"
                  />
                </svg>
              </div>
              <div className="applications__section__content__card__heading">
                Sensory Evaluation
              </div>
              <div className="applications__section__content__card__info">
                Trained experts carry out sensory evaluation of the prototypes
                to ensure the flavor delivers the desired sensory experience,
                from the initial impression to the lasting aftertaste.
              </div>
            </div>
          </SwiperSlide>
          <SwiperSlide>
            <div className="applications__section__content__card">
              <div className="applications__section__content__card__imgtwo">
                <svg
                  width="36"
                  height="24"
                  viewBox="0 0 36 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M2.66602 4.33306V1H33.219V5.44408L35.4411 7.66639V18.1676L33.219 20.4428V23.2204H2.66602V9.33264"
                    stroke="white"
                    strokeWidth="1.11102"
                    strokeMiterlimit="10"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                  <path
                    d="M14.332 17.6652H29.8863V19.8873H14.332V17.6652Z"
                    stroke="white"
                    strokeWidth="1.11102"
                    strokeMiterlimit="10"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                  <path
                    d="M11.5547 4.33255H29.8865V6.55459H11.5547V4.33255Z"
                    stroke="white"
                    strokeWidth="1.11102"
                    strokeMiterlimit="10"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                  <path
                    d="M8.22163 8.77663V4.33255H1V9.33214H4.40261"
                    stroke="white"
                    strokeWidth="1.11102"
                    strokeMiterlimit="10"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                  <path
                    d="M6 19.8876H8.22204V17.6655H6"
                    stroke="white"
                    strokeWidth="1.11102"
                    strokeMiterlimit="10"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
              </div>
              <div className="applications__section__content__card__heading">
                Prototyping and Testing
              </div>
              <div className="applications__section__content__card__info">
                Following formulation, we develop application prototypes. These
                are subjected to rigorous testing under real-world conditions to
                evaluate the stability, performance, and acceptability of the
                flavor.
              </div>
            </div>
          </SwiperSlide>
          <SwiperSlide>
            <div className="applications__section__content__card">
              <div className="applications__section__content__card__img">
                <svg
                  width="33"
                  height="26"
                  viewBox="0 0 33 26"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M24.0087 9.72548C24.0087 4.78217 18.8026 0.77832 12.3774 0.77832C5.95222 0.77832 0.746094 4.78217 0.746094 9.72548C0.746094 11.6435 1.53456 13.4106 2.87104 14.8701C2.12172 16.5589 0.885893 17.9009 0.869117 17.9177C0.746094 18.0463 0.712542 18.2365 0.785238 18.4042C0.857933 18.572 1.01451 18.6726 1.19345 18.6726C3.24011 18.6726 4.93448 17.9848 6.15353 17.2746C7.95415 18.1526 10.0847 18.6726 12.3774 18.6726C18.8026 18.6726 24.0087 14.6688 24.0087 9.72548ZM30.8309 22.0278C32.1674 20.5739 32.9559 18.8013 32.9559 16.8832C32.9559 13.1422 29.9642 9.93797 25.7254 8.60149C25.7758 8.97056 25.7981 9.34523 25.7981 9.72548C25.7981 15.6474 19.7756 20.4621 12.3774 20.4621C11.7735 20.4621 11.1863 20.4173 10.6047 20.3558C12.3662 23.5712 16.5043 25.8304 21.3246 25.8304C23.6173 25.8304 25.7478 25.3159 27.5484 24.4324C28.7675 25.1426 30.4618 25.8304 32.5085 25.8304C32.6875 25.8304 32.8496 25.7241 32.9167 25.562C32.9894 25.3998 32.9559 25.2097 32.8328 25.0755C32.8161 25.0587 31.5802 23.7222 30.8309 22.0278Z"
                    fill="white"
                  />
                </svg>
              </div>
              <div className="applications__section__content__card__heading">
                Refinement and Finalization
              </div>
              <div className="applications__section__content__card__info">
                Feedback from the sensory evaluation guides any necessary
                refinements to the flavor. Once the flavor meets our stringent
                standards, we move to finalization and production.
              </div>
            </div>
          </SwiperSlide>
          <SwiperSlide />
        </Swiper>
      </div>
    </section>
  );
}
